import React, { useState }  from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import db from "../../functions/firestore.js";

import {addMovie} from "../../functions/firestore.js";
import Loader from "../site/loader.js";



export default function NewMovie() {
  const { register, handleSubmit, control, errors } = useForm();
  const [ msg , setMsg] = useState('');

  const onSubmit = async(data) => {
    const check = await addMovie(data);
    if(check !== ""){
      Array.from(document.querySelectorAll("input")).forEach(
        input => (input.value = "")
      );
      setMsg(true);
    }else{
      setMsg(false);
    }
  };
  

  // const onSubmitManually = () => {
  //   cups.forEach(function(data) {
  //     const check = addMovie(data);
  //     console.log(check);
  //   });
  //   alert('done');
  // };
  
  
  // const checkReview = async () => {
  //   await db.collection("movies").where('enes_review', '==', 0).get().then(response => {
  //     response.docs.forEach(document => {
  //       console.log(JSON.stringify(document.data()));
  //     });
  //   });
  // };
  
  return (
    <div className = "container add_section">
        <div className = "row">
            <div className = "col-12">
                
                <form onSubmit={handleSubmit(onSubmit)}>
                <h2>New Movie</h2>
                <label>Title:</label>
                <input name="title" placeholder="Title" ref={register({ required: true })} />
                {errors.title && <span>This field is required</span>}
                
                <label>Year:</label>
                <input name="year" type='number' placeholder="Year" ref={register({ required: true })} /> 
                {errors.year && <span>This field is required</span>}

                <label>IMDB Category:</label>
                <Controller name="category" as={Select} styles={colourStyles} closeMenuOnSelect={false} options={options} isMulti control={control} defaultValue="" ref={register({ required: true })}/>
                {errors.category && <span>This field is required</span>}

                <label>Description(IMDB):</label>
                <input name="description" placeholder="Description" ref={register({ required: true })} />
                {errors.description && <span>This field is required</span>}

                <label>Movie Link(Link to IMDB):</label>
                <input name="movie_link" placeholder="Link: http//:" ref={register({ required: true })} />
                {errors.movie_link && <span>This field is required</span>}

                {/* <label>Movie Image (https://wall.alphacoders.com/):</label>
                <input name="movie_image" placeholder="Link: http//:" ref={register({ required: true })} />
                {errors.movie_image && <span>This field is required</span>}

                <label>Movie Thumnnail:</label>
                <input name="movie_thumbnail" placeholder="Link: http//:" ref={register({ required: true })} />
                {errors.movie_thumbnail && <span>This field is required</span>} */}


                {msg ? (
                  <div className="alert alert-success" role="alert">
                    <h4 className="alert-heading">Well done!</h4>
                    <p style={{color: '#155724'}}>Aww yeah, Movie has been added and it's waiting for review!</p>
                    <hr />
                    <p style={{color: '#155724'}} className="mb-0">Enjoy MovieArc and its features.</p>
                  </div>
                ) : (
                  <span>
                  </span>
                )}

                <input type="submit" />
                </form>
                {/* <a href="#" onClick={(e) => { e.preventDefault(); onSubmitManually(); }}>
                  CLICK HERE FOR MANUAL SUBMIT
                </a> */}                
                {/* <a href="#" onClick={(e) => { e.preventDefault(); checkReview(); }}>
                  CLICK HERE FOR MOVIES
                </a> */}
            </div>
        </div>
        <Loader />
    </div>
  );
}

const colourStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "#FC0",
      color: "#FFF",
      cursor: "pointer",
      border: "1px solid #FFF"
    };
  }
};

const options = [
    { value: 'Comedy', label: 'Comedy' },
    { value: 'Sci-Fi', label: 'Sci-Fi' },
    { value: 'Horror', label: 'Horror' },
    { value: 'Romance', label: 'Romance' },
    { value: 'Action', label: 'Action' },
    { value: 'Thriller', label: 'Thriller' },
    { value: 'Drama', label: 'Drama' },
    { value: 'Mystery', label: 'Mystery' },
    { value: 'Crime', label: 'Crime' },
    { value: 'Animation', label: 'Animation' },
    { value: 'Adventure', label: 'Adventure' },
    { value: 'Fantasy', label: 'Fantasy' },
    { value: 'Sport', label: 'Sport' },
    { value: 'Comedy-Romance', label: 'Comedy-Romance' },
    { value: 'Action-Comedy', label: 'Action-Comedy' },
    { value: 'Superhero', label: 'Superhero' },
  ]